<div class="flex flex-col gap-1">
  <!-- Data Missing - Red label -->
  <span *ngIf="(invoiceStatus === InvoiceStatus.DATA_MISSING || invoiceStatus === InvoiceStatus.CALCULATION_FAILED) && !adminApproved" 
        class="inline-flex items-center justify-center px-2 py-1 rounded-md text-sm font-semibold bg-error-300 text-error-700">
    {{ 'admin.status.data_incomplete' | transloco }}
  </span>

  <!-- Disputed - Orange label -->
  <span *ngIf="visibilityStatus === VisibilityStatus.UNDER_SILENT_ADMIN_REVIEW && invoiceStatus === InvoiceStatus.IN_DISPUTED" 
        class="inline-flex items-center justify-center px-2 py-1 rounded-md text-sm font-semibold bg-warning-300  text-warning-700">
    {{ 'admin.status.deviation_detected' | transloco }}
  </span>

  <!-- Review Requested - Green label -->
  <span *ngIf="invoiceStatus === InvoiceStatus.IN_DISPUTED && reviewRequested && !adminApproved" 
        class="inline-flex items-center justify-center px-2 py-1 rounded-md text-sm font-semibold bg-success-300 text-success-700">
    {{ 'admin.status.review_requested' | transloco }}
  </span>

  <!-- Spread Missing - Grey label -->
  <span *ngIf="isSpreadMissing" 
        class="inline-flex items-center justify-center px-2 py-1 rounded-md text-sm font-semibold bg-neutral-300 text-neutral-700">
    {{ 'admin.status.spread_missing' | transloco }}
  </span>

  <!-- Approved - Blue label -->
  <span *ngIf="adminApproved && visibilityStatus === VisibilityStatus.READY_FOR_USER" 
        class="inline-flex items-center justify-center px-2 py-1 rounded-md text-sm font-semibold bg-blue-300 text-blue-700">
    {{ 'admin.status.approved' | transloco }}
  </span>
</div>